// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ii_a bii_jk","CommentListPlaceholder--Legacy":"ii_b bii_rc bii_wq"};